import RegisterForm from './register-form'

export default RegisterForm
